const defaultState = () => ({
    users_for_admin_access: [],
    admin_access_users: []
});
export default defaultState;
